/**
 * StoreOrderPage — Pagina principale del form pubblico Store.
 * Route: /store/ordine (pubblica, no autenticazione)
 */
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { useChannel } from '../../Hooks/useChannel';
import ChannelBanner from '../../Components/store/ChannelBanner';
import OrderFormWizard from '../../Components/store/OrderForm/OrderFormWizard';

export default function StoreOrderPage() {
  const { channelInfo, loading, codiceCanale } = useChannel();
  const navigate = useNavigate();

  const handleSubmitSuccess = useCallback(
    (orderResponse) => {
      const refPath = codiceCanale ? `/store/conferma?ref=${encodeURIComponent(codiceCanale)}` : '/store/conferma';
      navigate(refPath, { state: { order: orderResponse } });
    },
    [navigate, codiceCanale]
  );

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-400 text-sm">Caricamento...</div>
      </div>
    );
  }

  return (
    <div className="h-screen overflow-hidden bg-gray-50 flex flex-col">
      {/* Channel banner */}
      <ChannelBanner channelInfo={channelInfo} />

      {/* Header */}
      <header className="bg-gradient-to-r from-white via-yellow-100 to-yellow-300 border-b border-yellow-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center gap-3">
          <ShieldCheck className="w-8 h-8 text-yellow-600" />
          <div>
            <h1 className="text-2xl font-bold text-gray-900">A-Sight Store</h1>
            <p className="text-sm text-gray-600">Attiva la protezione per la tua azienda</p>
          </div>
        </div>
      </header>

      {/* Form — grows to fill available space */}
      <main className="flex-1 min-h-0 max-w-7xl w-full mx-auto px-4 py-4">
        <OrderFormWizard
          channelInfo={channelInfo}
          codiceCanale={codiceCanale}
          onSubmitSuccess={handleSubmitSuccess}
        />
      </main>

      {/* Footer */}
      <footer className="border-t border-yellow-200 bg-gradient-to-r from-white via-yellow-50 to-yellow-100">
        <div className="max-w-7xl mx-auto px-4 py-4 text-center text-xs text-gray-500">
          © {new Date().getFullYear()} A-Sight — Innova-ware. Tutti i diritti riservati.
        </div>
      </footer>
    </div>
  );
}
